import React from 'react';
import { Form, useFormikContext } from 'formik';
import { IVisitorSearchFormValues } from './types';
import { FormGroup, MutedText } from '../../../form';
import { InputEmail } from '../../../formikBindings';
import { StepperButtons } from '../../../stepper';

const VisitorSearchForm: React.FC = () => {
  const { isSubmitting } = useFormikContext<IVisitorSearchFormValues>();

  return (
    <Form autoComplete="new-password">
      <FormGroup name="emailAddress" label="Email Address">
        <InputEmail
          name="emailAddress"
          isValidIndicator
          disabled={isSubmitting}
        />
      </FormGroup>

      {isSubmitting ? (
        <MutedText>Searching, please wait...</MutedText>
      ) : (
        <StepperButtons submitMode />
      )}
    </Form>
  );
};

export default VisitorSearchForm;
